import { configureStore } from '@reduxjs/toolkit';
import { appReducer } from './slices/app.slice';
import { userReducer } from './slices/user.slice';
import { dashboardReducer } from './slices/dashboard.slice';
import { employerReducer } from './slices/employer.slice';
import { broadcastReducer } from './slices/broadcast.slice';
import { applicationReducer } from './slices/application.slice';
import { chatReducer } from './slices/chat.slice';

export const store = configureStore({
  reducer: {
    app: appReducer,
    user: userReducer,
    dashboard: dashboardReducer,
    employer: employerReducer,
    broadcast: broadcastReducer,
    application: applicationReducer,
    chat: chatReducer,
  },
});
